module.exports = __webpack_public_path__ + "static/media/DSC00238.5ba4fc55.jpg";